import * as React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Linkedin, Twitter } from "lucide-react";
const platformLinks = [{
  label: "Recovery Engine",
  href: "/TheEnginePage"
}, {
  label: "CRM Integration",
  href: "#"
}, {
  label: "Voice Intelligence",
  href: "#"
}];
const solutionsLinks = [{
  label: "Mon–Fri: 0800–1800",
  href: "#"
}, {
  label: "Emergency: 24/7 AI",
  href: "#"
}, {
  label: "System Status: Active",
  href: "#"
}];
const companyLinks = [{
  label: "Command Center",
  href: "/CommandCenterPage"
}, {
  label: "The Engine",
  href: "/TheEnginePage"
}, {
  label: "Legacy Blueprint",
  href: "#"
}];
const legalLinks = [{
  label: "Privacy Protocol",
  href: "#"
}, {
  label: "Service Terms",
  href: "#"
}];
const socialLinks = [{
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}, {
  icon: Twitter,
  href: "#",
  label: "X (Twitter)"
}];
export default function PlatformFooter() {
  return <section data-section-id="132937" id="system-integrity-footer" className="bg-[#001829] text-[#F5F5DC]/80 py-16 lg:py-24 font-sans">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {}
          <div className="flex flex-col items-start gap-6">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606688/img/exergy_ops_bold_logo.png" alt="Exergy Ops" className="h-7 w-auto object-contain" />
            </Link>
          </div>

          {}
          <div>
            <h3 className="text-sm font-serif font-bold tracking-widest text-[#B5A642] uppercase">
              Infrastructure
            </h3>
            <ul className="mt-6 space-y-4">
              {platformLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-sm transition-colors hover:text-[#B5A642]">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-sm font-serif font-bold tracking-widest text-[#B5A642] uppercase">
              Operations
            </h3>
            <ul className="mt-6 space-y-4">
              {solutionsLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-sm transition-colors hover:text-[#B5A642]">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-sm font-serif font-bold tracking-widest text-[#B5A642] uppercase">
              System Integrity
            </h3>
            <ul className="mt-6 space-y-4">
              {companyLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="text-sm transition-colors hover:text-[#B5A642]">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="my-12 bg-[#B5A642]/20" />

        <div className="flex flex-col items-center justify-between gap-6 sm:flex-row">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
            <span className="text-[#F5F5DC]/60 uppercase tracking-tight">
              &copy; {new Date().getFullYear()} Exergy Ops. All rights reserved. — BUILT FOR LEGACY
            </span>
            {legalLinks.map((link, i) => <Link key={link.label} to={link.href} className="transition-colors hover:text-[#B5A642]" data-index={i}>
                {link.label}
              </Link>)}
          </div>

          <div className="flex items-center gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.label} to={social.href} className="text-[#F5F5DC]/60 transition-colors hover:text-[#B5A642]" aria-label={social.label} data-index={i}>
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>
        </div>
      </div>
    </section>;
}